import { useEffect, useState } from "react";

const LINKS = [
  { href: "#products", label: "Products" },
  { href: "#process", label: "Process" },
  { href: "#case-studies", label: "Facilities" },
  { href: "#pricing", label: "Volume Pricing" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 transition-all duration-200 ${
        scrolled
          ? "backdrop-blur-xl bg-white/85 border-b border-[#E5E5E5]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-link"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 group"
        >
          <span className="w-2.5 h-2.5 bg-[#DFFF00] inline-block group-hover:rotate-45 transition-transform" />
          <span className="font-display text-[17px] font-semibold tracking-tight">
            THE BALL BOSS
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollTo(l.href)}
              className="text-[13px] font-medium text-[#0A0A0A]/80 hover:text-[#0A0A0A] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#0A0A0A] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta-quote"
          onClick={() => scrollTo("#quote")}
          className="bg-[#0A0A0A] text-white px-5 py-2.5 text-[12px] font-medium tracking-wide uppercase hover:bg-[#DFFF00] hover:text-[#0A0A0A] transition-colors duration-200"
        >
          Request Quote
        </button>
      </div>
    </header>
  );
}
